import { render, staticRenderFns } from "./Agent.vue?vue&type=template&id=81d42454&scoped=true"
import script from "./Agent.vue?vue&type=script&lang=js"
export * from "./Agent.vue?vue&type=script&lang=js"
import style0 from "./Agent.vue?vue&type=style&index=0&id=81d42454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d42454",
  null
  
)

export default component.exports